<template>
  <div class="list-home" element-loading-text="正在加载中..." v-loading="loadings">
    <Nav v-show="imgslength > 0 && imgslength !== null"></Nav>
    <div class="nav_box">
      <div class="list-title">
        <div class="left_titles updatetext">选择类型：</div>
        <ol>
          <li class="liheight" v-for="(item, index) in getCate" :key="item.id" :class="{ active: topCurrent == index }"
            @click="titleSlide(item.id, index, '', 'ni')">
            {{ item.name }}
          </li>
        </ol>
      </div>
      <div class="list-title">
        <div class="left_titles">选择学科：</div>
        <ol>
          <li v-for="(item, index) in list.one" :key="index" :class="{ active: listOneActive == index }"
            @click="choose(1, item.id, index, 'ns')">
            {{ item.name }}
          </li>
        </ol>
      </div>
      <!--<div class="list-title" v-if="list.two && list.two.length > 0">
				<div class="left_titles">选择学科：</div>
				<ol>
					<li v-for="(item,index) in list.two" :key="item.id" :class="{ active: listTwoActive == index }"
						@click="choose(2, item.id, index)">
						{{ item.name }}
					</li>
				</ol>
			</div> -->
      <div class="list-title">
        <div class="left_titles">选择试题</div>
        <ol>
          <li v-for="(item, index) in shitiType" :key="item.id" :class="{ active: answerList == index }"
            @click="listTabSlide(index, typeId, item.name, 'tab', 'ns')">
            <span class="itemclass">{{ item.name }}</span>
          </li>
        </ol>
      </div>
    </div>
    <div class="content_box">
      <div class="list">
        <div class="box_title">
          <img src="/images/icon_tk_05.png" alt="" />{{ titleName }}
        </div>
        <div class="list-con">
          <div class="list-tab">
            <div class="list-sapce"></div>

            <div class="list-tab-con" :style="listTabStyle"
              style="height: 150px; line-height: 150px; text-align: center" v-if="list.mid.data == ''">
              暂无数据
            </div>
            <div class="list-tab-con" :style="listTabStyle" v-else>
              <div class="list-box" v-for="(item, index) in list.mid.data" :key="item.id" :class="{
                'list-box-active': listBoxActive == index,
              
                //'list-single': item.jie == '',
              }" @click="
  titleName == '专项训练'
    ? ''
    : openListAnswer(
      item.id,
      item.number,
      '',
      index,
      item.name,
      statenum
    )
">
                <div class="list-tab-a-box">
                  <div class="list-tab-a" @click="slideOpen(item.id, index)" :class="{
                    'list-box-actives': listBoxActive == index,
                  }">
                    <i></i>
                    <p>{{ item.name }}</p>
                    <div v-if="answerList == 0">
                      已练： {{ item.user_num }}/{{ item.exam_num }}
                    </div>
                  </div>

                  <div class="circlechart" @click="item.jie !== '' && openTabAnswer(index)">
                    <div class="list-box-list-two" v-if="answerList == '2'">
                      <!--  @mouseover.stop="showHint(index)"
                        @mouseout.stop="showHint(index,'ns')" -->

                      <span v-if="item.text_url != '' && item.text_url != null"
                        @click.stop="openurls(item.text_url[0].url)" class="list-box-list-two-low">
                        <img src="/images/downloads.png"> 免费下载
                        <!-- <transition name="el-fade-in">
                            <div v-if="shows[index]"> <span class="download">
                                                  <img   style="rights"  src="/images/rights.png" alt="">
                                                打开~
                                              </span></div>
                          </transition> -->
                      </span>
                      <img v-if="item.price >= 10" src="/images/vip1.png" alt="" />
                    </div>
                    <div v-else-if="answerList == '7'">
                      <img v-if="item.user_num > 0" src="/images/test_7_h.png" style="width: 16px; height: 16px" alt />
                      <img v-else src="/images/test_7.png" style="width: 16px; height: 16px" alt />
                    </div>
                    <div v-else-if="answerList == '0'" @click="slideOpen(item.id, index)">
                      <img v-if="item.user_num > 0" src="/images/test_7_h.png" style="width: 16px; height: 16px" alt />
                      <img v-else src="/images/test_7.png" style="width: 16px; height: 16px" alt />
                      <el-progress v-if="item.user_num > 0" type="circle" :percentage="
                        item.user_num == 0
                          ? Number(zeroNum)
                          : Number((item.user_num / item.exam_num) * 100)
                      " :width="30" :stroke-width="2" color="#e60012" :show-text="false">
                      </el-progress>
                    </div>
                    <template v-else>
                      <el-progress v-if="data.length > 0" type="circle" :percentage="
                        item.user_num == 0
                          ? Number(zeroNum)
                          : Number((item.user_num / item.exam_num) * 100)
                      " :width="30" :stroke-width="2" color="#e60012" :show-text="false">
                      </el-progress>
                    </template>
                  </div>
                </div>
                <el-collapse-transition>
                  <div class="contant" v-if="listBoxActive == index">
                    <div class="list-tab-b-box" v-for="(item, index) in item.jie" :key="index">
                      <div class="list-tab-b" @click="subopen(index)" :class="{
                        'list-box-actives': sbuActive == index,
                      }">
                        <i></i>
                        <p>{{ item.name }}</p>
                        <div>已练：{{ item.user_num }}/{{ item.exam_num }}</div>
                      </div>
                      <div class="circlechart1">
                        <div @click="subopen(index)">
                          <img v-if="item.user_num > 0" src="/images/test_7_h.png" style="width: 16px; height: 16px"
                            alt />
                          <img v-else src="/images/test_7.png" style="width: 16px; height: 16px" alt />

                          <el-progress v-if="item.user_num > 0" type="circle" :percentage="
                            item.user_num == 0
                              ? Number(zeroNum)
                              : Number((item.user_num / item.exam_num) * 100)
                          " :width="30" :stroke-width="2" color="#e60012" :show-text="false"></el-progress>
                        </div>
                      </div>

                      <el-collapse-transition>
                        <div class="contant" v-if="sbuActive == index">
                          <div class="list-tab-b-box" v-for="item in item.sub" :key="item.ques_id" @click="
                            openListAnswer(
                              item.id,
                              item.exam_num,
                              item.user_num
                            )
                          ">
                            <div class="list-tab-b list-tab-bs">
                              <p>{{ item.name }}</p>
                              <div>
                                已练：{{ item.user_num }}/{{ item.exam_num }}
                              </div>
                            </div>
                            <div class="circlechart1">
                              <div>
                                <img v-if="item.user_num > 0" src="/images/test_7_h.png"
                                  style="width: 16px; height: 16px" alt />
                                <img v-else src="/images/test_7.png" style="width: 16px; height: 16px" alt />
                                <el-progress type="circle" :percentage="
                                  item.user_num == 0
                                    ? Number(zeroNum)
                                    : Number(
                                      (item.user_num / item.exam_num) * 100
                                    )
                                " :width="30" :stroke-width="2" color="#e60012" :show-text="false"></el-progress>
                              </div>
                            </div>
                          </div>
                        </div>
                      </el-collapse-transition>
                    </div>
                  </div>
                </el-collapse-transition>
              </div>
            </div>
            <div class="list-page" v-if="list.mid.data != ''">
              <el-pagination v-show="list.mid.count > 8" background layout="prev, pager, next" :total="list.mid.count"
                :page-size="10" prev-text="上一页" next-text="下一页" @current-change="changeCurrentPage"
                :current-page="Number(currentPage)"></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <div class="list-right">
        <div class="test-login" v-if="!userToken">
          <img src="images/13.png" />
          <el-button type="primary" @click="openLogin('login')">立即登录</el-button>
          <el-dialog :visible.sync="showLogin" :append-to-body="true" :show-close="false" width="400px" v-if="showLogin"
            :close-on-click-modal="false">
            <Login :loginType="loginType" v-on:listenLogin="listenLogin" @show="onlin"></Login>
          </el-dialog>
        </div>
        <div v-else>
          <el-collapse-transition>
            <el-row class="block-col-2">
              <el-col :span="12">
                <span class="demonstration"></span>
                <el-dropdown>
                  <span class="el-dropdown-link list-lasts">
                    <img src="/images/icon_tk_04.png" />练习记录
                    <i class="el-icon-arrow-down"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="opemurl(item)" v-for="(item, index) in Answerrecord" :key="index">
                      <span class="demonstrationspan">{{ item.name }}</span>
                    </el-dropdown-item>
                    <!-- <p class="demonstrationspanspan1"  style="">  <img src="/images/134.png" /><span >{{item.time}}</span></p>  -->
                    <el-dropdown-item v-show="Answerrecord == ''">
                      暂无记录
                    </el-dropdown-item>

                    <p></p>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-col>
            </el-row>
          </el-collapse-transition>
          <div class="list-total">
            <h3>{{ CategoryData.name }}</h3>
            <div class="circlechart2">
              <span>{{ CategoryData.rate || 0 }}%</span>
              <el-progress type="circle" :percentage="
                CategoryData.rate ? Number(CategoryData.rate) : 0.1
              " :width="130" :stroke-width="8" color="#e60012" :show-text="false"></el-progress>
            </div>
            <p>完成率</p>
            <p>
              <span>
                <em>{{ CategoryData.num || 0 }}</em>参与人数
              </span>
              <span>
                <em>{{ CategoryData.accuracy || 0 }}%</em>正确率
              </span>
            </p>
          </div>
          <div class="list-data">
            <h3><img src="/images/icon_tk_03.png" />数据统计</h3>
            <p>
              <router-link title="我的错题" to="/user/wrong">
                <img src="/images/10.png" />我的错题
                <em>{{ PersonalData.error }}</em>
              </router-link>
            </p>
            <p>
              <router-link title="我的收藏" to="/user/collect">
                <img src="/images/11.png" />我的收藏
                <em>{{ PersonalData.favorite }}</em>
              </router-link>
            </p>
            <p>
              <router-link title="我的笔记" to="/user/note">
                <img src="/images/12.png" />我的笔记
                <em>{{ PersonalData.note }}</em>
              </router-link>
            </p>
            <p>
              <a title="用户报告" @click="showReport = true">
                <img src="/images/14.png" />用户报告
                <em>
                  <i class="el-icon-arrow-right"></i>
                </em>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="showReport" width="520px">
      <div class="win-report">
        <span class="win-report-close" @click="showReport = false">
          <i class="el-icon-close"></i>
        </span>
        <div>
          <p>
            <img src="/images/qqqun.png" alt />
          </p>
        </div>
        <em>扫一扫下载——莘知教育APP</em>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Login from "@/components/Login.vue";
import Nav from "@/components/nav.vue";
import EventBus from "../../eventBus/eventBus";

export default {
  name: "list-home",
  inject: ["reload"],

  data() {
    return {
      sf: {
        insN: "nin",
      },
      getCate: [],
      zhuId: "",
      typeId: "",
      topCurrent: 0,
      loadings: false,
      list: { mid: [] },
      wxurl: "",
      shitiType: [
        {
          type: 1,
          name: "专项训练",
        },
        {
          type: 2,
          name: "随机练习",
        },
        {
          type: 3,
          name: "历年真题",
        },
        {
          type: 4,
          name: "冲刺密卷",
        },
        {
          type: 5,
          name: "公告模考",
        },
        {
          type: 6,
          name: "考试估分",
        },
        {
          type: 7,
          name: "模拟考试",
        },
        {
          type: 9,
          name: "时事政治",
        },
      ],
      Answerrecord: [],
      PersonalData: [],
      vipced: "",
      CategoryData: [],
      listTab: [],
      answerList: 0,
      listTabStyle: {
        borderRadius: "0 18px 18px 18px",
      },
      time: "",
      imgslength: null,
      listBoxActive: "-1",
      listOneActive: 0,
      listTwoActive: "0",
      listTabIndex: "0",
      currentPage: 1,
      listTid: "",
      listMid: 0,
      timestamp: "",
      zxMid: "574",
      showLogin: false,
      loginType: "",
      showReport: false,
      zeroNum: "0.1",
      numStorge: "",
      once: true,
      lastPracticeData: [],
      data: "",
      titleName: "专项训练",
      page: 1,
      limit: 1,
      sbuActive: "3333",
      userToken: localStorage.getItem("UserToken"),
      statenum: 0,
      codeindex: 0,
      shows: []
    };
  },
  methods: {
    //分类切换
    titleSlide(id, index, nn, ni) {
      console.log(index, id, "yiji");
      sessionStorage.setItem("yijiid", id);
      sessionStorage.setItem("yijiindex", index);
      if (ni == "ni") {
        sessionStorage.removeItem("erjiid");
        sessionStorage.removeItem("erjiindex");
        sessionStorage.removeItem("sanjiindex");
        sessionStorage.removeItem("sanjiname");
      }
      this.codeindex = 0;
      // this.$loading(true);
      this.topCurrent = index;
      this.listOneActive = 0;
      this.page = 1;
      this.answerList = 0;
      this.currentPage = 1;
      this.zhuId = id;
      this.$api
        .getCateVice({
          main_id: id,
          city: localStorage.getItem("cityId"),
        })
        .then((res) => {
          console.log(res);
          this.list.one = res.data;

          // this.getCategoryDatas(res.data[0].id, 1)
          if (sessionStorage.getItem("erjiid") && ni !== "ni") {
            console.log("一级一选项");
            this.choose(
              "",
              sessionStorage.getItem("erjiid"),
              sessionStorage.getItem("erjiindex")
            );
          } else {
            if (sessionStorage.getItem("sanjiindex")) {
              console.log("三级选择");
              sessionStorage.getItem("sanjiindex") === 1
                ? this.listTabSlide(0, res.data[0].id, this.shitiType[0].name)
                : this.listTabSlide(
                  sessionStorage.getItem("sanjiindex"),
                  sessionStorage.getItem("sanjiid"),
                  sessionStorage.getItem("sanjiname")
                );
            } else {
              console.log("一级二选项");
              this.listTabSlide(0, res.data[0].id, this.shitiType[0].name);
            }
          }

          this.$loading().close();
          this.$forceUpdate();
        });
    },
    //答题记录跳转
    opemurl(item) {
      var that = this;
      this.$router.push({
        path: "/answerPastReal",
        query: {
          quesId: item.quesId, //试卷id
          type: item.type, // 试卷类型	1:历年真题；2：冲刺密卷；3：模拟考试；4：考试估分；5：公告模考；6：时事政治
          number: item.number, //试卷题目长度
          zhuId: item.zhuId,
          typeId: item.typeId,
          name: item.name,
          statenum: item.statenum,
          tiname: item.tiname,
        },
      });
    },
    getCategoryDatas(id, type, ns) {
      if (ns === "ns") {
        return;
      }

      //  this.$loading().close();
      //console.log(id,type)
      if (localStorage.getItem("UserToken")) {

        this.$api
          .getCategoryData({
            cate_id: this.typeId,
            type: type,
          })
          .then((res) => {
            console.log(res)
            if (res.data) {
              //console.log(res)
              this.CategoryData = res.data.data;

              this.CategoryData.name = JSON.parse(
                localStorage.getItem("cityId")
              ).nickname;
              //console.log(res.data.user.vip_last_time)
              let ip = localStorage.getItem('cityId')
              const resultList = res.data.user.vip_info.filter(item => {

                return item.vip_area == ip;
              });
              console.log(resultList)

              localStorage.setItem("vip", resultList.length > 0 ? resultList[0].vip_last_time : 'error');
              this.getItems();
            }
          });
      }
    },
    onlin(show) {
      //console.log(show)
      this.showLogin = show;
    },
    //分类选择按钮
    choose(a, id, index, ns) {
      sessionStorage.setItem("erjiid", id);
      sessionStorage.setItem("erjiindex", index);
      if (ns == "ns") {
        sessionStorage.removeItem("sanjiindex");
        sessionStorage.removeItem("sanjiname");
      }
      console.log("二级", index, id);
      this.codeindex = 0;
      this.answerList = 0;
      this.page = 1;
      this.answerList = 0;
      this.currentPage = 1;
      this.listOneActive = index;
      if (a == 1) {
        this.listOneActive = index;

        this.listMid = 0;
      } else if (a == 2) {
        this.listTwoActive = index;
      }
      // this.getData(this.user_id, id, this.listMid);
      if (!sessionStorage.getItem("sanjiindex")) {
        this.listTabSlide(0, id, this.titleName, "", "ns");
        console.log("三级2");
      } else {
        console.log("三级1");

        sessionStorage.getItem("sanjiindex") == 1
          ? this.listTabSlide(0, id, this.titleName, "", "ns")
          : this.listTabSlide(
            sessionStorage.getItem("sanjiindex"),
            id,
            sessionStorage.getItem("sanjiname"),
            "",
            "ne"
          );
      }

      this.currentPage = 1;
      this.listTid = id;
    },
    //专项切换
    listTabSlide(index, id, titleName, type, ns) {
      console.log(index, id, titleName);

      if (index == 0 && this.codeindex != 0) {
        return;
      }
      if (type == "tab") {
        this.page = 1;
        this.currentPage = 1;
        sessionStorage.setItem("sanjiindex", index);
        sessionStorage.setItem("sanjiname", titleName);
        sessionStorage.setItem("sanjiid", id);
        //console.log(this.page)
        //console.log(this.currentPage)
      }
      // this.page=1
      localStorage.setItem("listName", index);
      this.statenum = index;
      localStorage.setItem("listid", id);
      localStorage.setItem("listtitle", titleName);
      this.$loading(true);
      // //console.log(this.$loading,"loading")
      this.answerList = index;
      this.typeId = id;
      this.titleName = titleName;
      let userid =
        localStorage.getItem("userId") !== null
          ? localStorage.getItem("userId")
          : 0;
      //console.log(userid,'www')
      console.log("专项切换", index, titleName, id);
      if (index == 0) {
        this.codeindex = 1;
        this.$api
          .GetPieceData({
            cate_id: id,
            city_id: localStorage.getItem("cityId"),
            main_id: this.zhuId,
            page: this.page,
            limit: 9,
            user_id: userid,
          })
          .then((res) => {
            //console.log(res.data)

            this.list.mid = res.data;
            this.getCategoryDatas(this.typeId, 1, ns);
            if (ns) {
              this.$loading().close();
            }

            this.$forceUpdate();
          });
      } else if (index == 1) {
        this.codeindex = 0;
        if (this.userToken == "" || !this.userToken) {
          this.loginType = "login";
          this.showLogin = true;
          // this.$message.error("请先登录");

          this.answerList = 0;
          this.$loading().close();
          return;
        }
        this.$loading().close();
        if (type == "tab") {
          this.$router.push(
            "/answeRandom?main_id=" +
            this.zhuId +
            "&cate_id=" +
            this.typeId +
            "&type=2"
          );
        }
      } else {
        if (index == null) {
          return;
        }
        this.codeindex = 0;
        // this.$loading(true)
        this.$loading().close();
        let status;
        let type;
        if (index == 2) {
          status = 1;
          type = 3;
        } else if (index == 3) {
          status = 2;
          type = 4;
        } else if (index == 4) {
          status = 5;
          type = 5;
        } else if (index == 5) {
          status = 4;
          type = 6;
        } else if (index == 6) {
          status = 3;
          type = 7;
        } else if (index == 7) {
          status = 6;
          type = 9;
        }

        this.$api
          .getQuesList({
            cate_id: this.typeId,
            city_id: localStorage.getItem("cityId"),
            status: status,
            page: this.page,
            limit: 10,
          })
          .then((res) => {
            console.log(res);
            //console.log(this.list)
            this.list.mid = res.data;
            this.$set(this.list.mid.data, 0, this.list.mid.data[0])
            this.getCategoryDatas(this.typeId, type);
            this.$forceUpdate();
          });
      }
      // if (index == "5") {
      // 	this.$router.push({
      // 		path: "/answeRandom",
      // 		query: {
      // 			cate_id: this.listTid,
      // 		},
      // 	});
      // } else {
      // 	if (index == "0") {
      // 		this.listTabStyle.borderRadius = "0 18px 18px 18px";
      // 	} else {
      // 		this.listTabStyle.borderRadius = "18px";
      // 	}
      // 	this.getData(this.user_id, this.listTid, id);
      // 	this.listMid = id;
      // 	this.currentPage = "1";
      // 	this.listTabIndex = index;
      // }
    },
    //展开收起
    subopen(index) {
      //console.log(index)
      if (this.sbuActive == index) {
        this.sbuActive = -1;
      } else {
        this.sbuActive = index;
      }
    },
    slideOpen(piece_id, index) {
      console.log(this.answerList);
      // this.$loading(true)
      // if (this.answerList !== 0) {

      // 	return
      // }
      //console.log("加载中")

      this.list.mid.data[index].jie = [];
      let userid =
        localStorage.getItem("userId") !== null
          ? localStorage.getItem("userId")
          : 0;
      this.$api
        .getChapterData({
          cate_id: this.typeId,
          piece_id: piece_id,
          main_id: this.zhuId,
          user_id: userid,
        })
        .then((res) => {
          //console.log(res)
          this.list.mid.data[index].jie = res.data;
          this.$forceUpdate();
          //console.log(this.list.mid.data[index].jie,'111')
        });

      if (this.listBoxActive == index) {
        this.listBoxActive = "-1";
      } else {
        this.listBoxActive = index;
      }
    },

    //分类数据
    getData(uid, tid, mid = this.zxMid, page = 1) {
      let that = this;
      // //console.log(uid,tid,mid,page)
      // return
      this.$loading();
      this.$api.getCate().then((res) => {
        that.getCate = res.data;
        if (!this.list.ong) {
          if (sessionStorage.getItem("yijiid")) {
            this.titleSlide(
              sessionStorage.getItem("yijiid"),
              sessionStorage.getItem("yijiindex"),
              "nn"
            );
            console.log("保存");
          } else {
            console.log("未保存");
            this.titleSlide(that.getCate[0].id, 0);
          }
        }
        this.$forceUpdate();
      });

      return;
      this.list = [];
      var param = {
        uid: uid,
        tid: tid,
        mid: mid,
        page: page,
        city: localStorage.getItem("indexRegionId"),
      };
      this.$post("defaultTidTwo", param).then((res) => {
        //console.log(res)
        this.$loading().close();
        this.list = res.data;
        // //console.log(res);
        if (this.list.two) {
          this.listTid = this.list.two[this.listTwoActive].id;
        } else {
          this.listTid = this.list.one[this.listOneActive].id;
        }

        this.list.mid.arr.forEach((item, id) => {
          item.jie.forEach((e) => {
            if (localStorage.getItem(e.id)) {
              e.answer_num += JSON.parse(localStorage.getItem(e.id)).length;
              item.answer_num += JSON.parse(localStorage.getItem(e.id)).length;
            }
          });
        });

        // this.numStorge = localStorage.getItem(id)
      });
      this.getCategoryData(tid);
    },
    //获取right数据
    getPersonalData(uid) {
      var param = {
        uid: uid,
      };
      this.$post("getPersonalData", param).then((res) => {
        if (res.data) {
          this.PersonalData = res.data;
        }
      });
    },
    getCategoryData(tid) {
      var param = {
        tid: tid,
        uid: this.user_id,
        city: localStorage.getItem("indexRegionId"),
      };
      this.$post("getCategoryData", param).then((res) => {
        this.CategoryData = res.data;
      });
    },
    //章跳转
    openTabAnswer(index) {
      var that = this;
      var path;
      var type;
      if (this.listTabIndex == "0") {
        path = "/answerSpecialItem";
        type = 1;
      } else if (this.listTabIndex == "1") {
        this.$message({
          type: "info",
          message: "考试估分暂未开放！",
          duration: 2000,
        });
      } else if (this.listTabIndex == "2") {
        path = "/answerPastReal";
        type = 3;
      } else if (this.listTabIndex == "3") {
        path = "/answerPastReal";

        type = 4;
      } else {
        this.$message({
          type: "info",
          message: "公告模考暂未开放！",
          duration: 2000,
        });
      }
      if (!localStorage.getItem("user_id") || this.user_id == "") {
        this.openLogin("login");
      } else {
        var _jie = this.list.mid.arr[index].jie;
        for (let i = 0; i < _jie.length; i++) {
          if (_jie[i].answer_num < _jie[i].ques_num) {
            if (_jie[i].is_charge == 0) {
              this.$router.push({
                path: path,
                query: {
                  sub_id: _jie[i].id,
                  type: type,
                },
              });
            } else {
              if (this.user_vip == "1") {
                this.$router.push({
                  path: path,
                  query: {
                    sub_id: _jie[i].id,
                    type: type,
                  },
                });
              } else {
                this.openListVip();
              }
            }

            break;
          } else {
            if (i + 1 >= _jie.length) {
              this.listAnswerReset(path, _jie[i].id, type);
            } else {
              this.$router.push({
                path: path,
                query: {
                  sub_id: _jie[i + 1].id,
                  type: type,
                },
              });
            }
          }
        }
      }
    },
    //单题  节跳转
    openListAnswer(qid, a_num, q_num, index, name, statenum) {
      console.log(a_num, q_num, "ssssssssssssssssssss")
      //console.log(this.userToken,"wwwwwwwww")
      if (this.userToken == "" || !this.userToken) {
        this.loginType = "login";
        this.showLogin = true;
        // this.$message.error("请先登录");
        return;
      }
      let date = new Date();

      var h = date.getHours() + ":";
      var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var s = date.getSeconds();

      let query = {
        quesId: qid, //试卷id
        type: 1, // 试卷类型	1:历年真题；2：冲刺密卷；3：模拟考试；4：考试估分；5：公告模考；6：时事政治
        number: a_num, //试卷题目长度
        zhuId: this.zhuId,
        typeId: this.typeId,
        name: name,
        time: h + m + s,
        statenum: statenum,
        tiname: localStorage.getItem("listtitle"),
      };
      if (this.titleName == "历年真题") {
        //console.log(this.vipced)
        //console.log(qid, a_num, index);
        //console.log(this.list.mid.data[index].price)

        // return

        if (this.list.mid.data[index].price >= 10) {
          console.log("测试", this.vipced);
          if (this.vipced) {
            this.$router.push({
              path: "/answerPastReal",
              query: {
                quesId: qid, //试卷id
                type: 1, // 试卷类型	1:历年真题；2：冲刺密卷；3：模拟考试；4：考试估分；5：公告模考；6：时事政治
                number: a_num, //试卷题目长度
                zhuId: this.zhuId,
                typeId: this.typeId,
                name: name,
              },
            });
            this.Answerrecord.push(query);
            localStorage.setItem("record", JSON.stringify(this.Answerrecord));
          } else {
            this.$message.error(
              `您未开通${localStorage.getItem('city')}地区会员,请下载莘知教育app购买会员或联系客服购买`
            );
            return;
          }
        } else {
          this.$router.push({
            path: "/answerPastReal",
            query: {
              quesId: qid, //试卷id
              type: 1, // 试卷类型	1:历年真题；2：冲刺密卷；3：模拟考试；4：考试估分；5：公告模考；6：时事政治
              number: a_num, //试卷题目长度
              zhuId: this.zhuId,
              typeId: this.typeId,
              name: name,
            },
          });
          this.Answerrecord.push(query);
          localStorage.setItem("record", JSON.stringify(this.Answerrecord));
        }
      } else if (this.titleName == "冲刺密卷") {
        this.$router.push({
          path: "/answerPastReal",
          query: {
            quesId: qid, //试卷id
            type: 2, // 试卷类型	1:历年真题；2：冲刺密卷；3：模拟考试；4：考试估分；5：公告模考；6：时事政治
            number: a_num, //试卷题目长度
            zhuId: this.zhuId,
            typeId: this.typeId,
            name: name,
          },
        });
        this.Answerrecord.push(query);
        localStorage.setItem("record", JSON.stringify(this.Answerrecord));
      } else if (this.titleName == "公告模考") {
        this.$router.push({
          path: "/answerPastReal",
          query: {
            quesId: qid, //试卷id
            type: 5, // 试卷类型	1:历年真题；2：冲刺密卷；3：模拟考试；4：考试估分；5：公告模考；6：时事政治
            number: a_num, //试卷题目长度
            zhuId: this.zhuId,
            typeId: this.typeId,
            name: name,
          },
        });
        this.Answerrecord.push(query);
        localStorage.setItem("record", JSON.stringify(this.Answerrecord));
      } else if (this.titleName == "考试估分") {
        this.$router.push({
          path: "/answerPastReal",
          query: {
            quesId: qid, //试卷id
            type: 4, // 试卷类型	1:历年真题；2：冲刺密卷；3：模拟考试；4：考试估分；5：公告模考；6：时事政治
            number: a_num, //试卷题目长度
            zhuId: this.zhuId,
            typeId: this.typeId,
            name: name,
          },
        });
        this.Answerrecord.push(query);
        localStorage.setItem("record", JSON.stringify(this.Answerrecord));
      } else if (this.titleName == "模拟考试") {
        this.$router.push({
          path: "/answerPastReal",
          query: {
            quesId: qid, //试卷id
            type: 3, // 试卷类型	1:历年真题；2：冲刺密卷；3：模拟考试；4：考试估分；5：公告模考；6：时事政治
            number: a_num, //试卷题目长度
            zhuId: this.zhuId,
            typeId: this.typeId,
            name: name,
          },
        });
        this.Answerrecord.push(query);
        localStorage.setItem("record", JSON.stringify(this.Answerrecord));
      } else if (this.titleName == "时事政治") {
        this.$router.push({
          path: "/answerPastReal",
          query: {
            quesId: qid, //试卷id
            type: 6, // 试卷类型	1:历年真题；2：冲刺密卷；3：模拟考试；4：考试估分；5：公告模考；6：时事政治
            number: a_num, //试卷题目长度
            zhuId: this.zhuId,
            typeId: this.typeId,
            name: name,
            index: 7,
          },
        });
        this.Answerrecord.push(query);
        localStorage.setItem("record", JSON.stringify(this.Answerrecord));
      } else if (this.titleName == "专项训练") {
        //console.log(this.list.mid.data)
        console.log(qid)
        if (a_num <= q_num) {
          console.log("qid")
          this.listAnswerReset(qid);

          return;
        }
        this.$router.push(
          "/answeRandom?main_id=" +
          this.zhuId +
          "&cate_id=" +
          this.typeId +
          "&type=1" +
          "&sub_id=" +
          qid
        );
        // this.$router.push({
        // 	path: "/answerSpecialItem",
        // 	query: {

        // 		sub_id: qid, //小节
        // 		type: 6, // 试卷类型	1:历年真题；2：冲刺密卷；3：模拟考试；4：考试估分；5：公告模考；6：时事政治
        // 		number: a_num, //试卷题目长度
        // 		zhuId: this.zhuId, //主分类id
        // 		typeId: this.typeId, //分类id
        // 	},
        // });
      }

      var path;
      var type;
      if (this.listTabIndex == "0") {
        path = "/answerSpecialItem";
        type = 1;
      } else if (this.listTabIndex == "1") {
        this.$message({
          type: "info",
          message: "考试估分暂未开放！",
          duration: 2000,
        });
      } else if (this.listTabIndex == "2") {
        path = "/answerPastReal";
        type = 3;
      } else if (this.listTabIndex == "3") {
        path = "/answerPastReal";
        type = 4;
      } else {
        this.$message({
          type: "info",
          message: "公告模考暂未开放！",
          duration: 2000,
        });
      }
      if (!localStorage.getItem("user_id") || this.user_id == "") {
        this.openLogin("login");
      } else {
        if (a_num >= q_num) {

          console.log("11111111111111121")
          // this.listAnswerReset(path, qid, type);
        } else {
          this.$router.push({
            path: path,
            query: {
              sub_id: qid,
              type: type,
            },
          });
        }
      }
    },
    // 重置
    listAnswerReset(qid) {
      console.log()
      this.$confirm("已答完所有题，是否重置？", "重置", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          var param = {
            sub_id: qid,
            main_id: this.zhuId,
            cate: 1,
            type: 1,
          };
          this.$api.resetAnswer(param).then((res) => {
            this.$message({
              type: "success",
              message: "重置成功",
              duration: 2000,
            });
            this.getData(this.user_id, this.listTid, this.listMid);
          });
          return;
          this.$post("reset", param).then((res) => {
            if (res.code == "200") {
              // this.$route.go(0);
              this.$message({
                type: "success",
                message: "重置成功",
                duration: 2000,
              });
              setTimeout(() => {
                this.$router.push({
                  path: path,
                  query: {
                    sub_id: qid,
                    type: ty,
                  },
                });
              }, 2000);
            }
          });
        })
        .catch((action) => {
          // this.$message({
          // 	type: "info",
          // 	message: "取消重置",
          // });
        });
    },
    // 显示下载提醒
    showHint(index, ns) {

      if (ns === 'ns') {
        this.shows[index] = false
        this.$set(this.shows, 0, this.shows[0])
        return
      }
      this.shows[index] = true
      console.log(this.shows[index])
      this.$set(this.shows, 0, this.shows[0])
    },

    //分页
    changeCurrentPage(currentPage) {
      this.currentPage = currentPage;
      this.page = currentPage;

      //console.log(this.answerList, this.typeId, this.titleName,"this.answerList, this.typeId, this.titleName")
      this.listTabSlide(this.answerList, this.typeId, this.titleName);
      // this.getData(this.user_id, this.listTid, this.listMid, currentPage);
      window, scrollTo(0, 0);
    },
    //单题 节跳转  vip
    openListVip() {
      if (!localStorage.getItem("user_id") || this.user_id == "") {
        this.openLogin("login");
      } else {
        this.$message({
          message: "请开通对应地区vip！",
          type: "error",
          showClose: true,
        });
      }
    },
    openLogin(item) {
      this.showLogin = true;
      this.loginType = item;
    },
    //监听子组件的值
    listenLogin(item) {
      this.loginType = item;
    },
    openurls(url) {
      if (this.userToken == "" || !this.userToken) {
        this.loginType = "login";
        this.showLogin = true;
        this.$message.error("请先登录");
        return;
      }
      window.open(url);
    },
    //上次练习
    lastPractice() {
      this.$post("lastPractice", {
        uid: this.user_id,
      }).then((res) => {
        this.lastPracticeData = res.data;
      });
    },
    openLastAnswer(item) {
      if (item.answer_num < item.ques_num) {
        this.$router.push({
          path: "/answerSpecialItem",
          query: {
            sub_id: item.sub_id,
            type: item.type,
          },
        });
      } else {
        this.listAnswerReset("/answerSpecialItems", item.sub_id, item.type);
      }
    },
    //获取时间戳
    async getItems() {
      this.time = localStorage.getItem("vip");
      console.log(this.time)
      if (this.time != " " || this.time != null) {
        //console.log(this.time*1000- new Date().getTime()>0  )
        //console.log( new Date().getTime())
        //console.log(localStorage.getItem('UserToken') &&  localStorage.getItem('UserToken') !== '' )
        if (
          localStorage.getItem("UserToken") &&
          localStorage.getItem("UserToken") !== ""
        ) {
          if (this.time * 1000 - new Date().getTime() > 0) {

            this.vipced = true;
            console.log(this.vipced)
          } else {

            this.vipced = false;

            console.log(this.vipced)
          }
        } else {
          this.vipced = false;
        }
      }
    },

    // 微信登录 //qq登录
    async geturl() {

      //  const  data  = await	this.$api.qqCallBack({ state:980614,code:''})
      //  //console.log(data)
      // let bindType =localStorage.getItem('bindType')
      //console.log(bindType)
      // if(bindType =='' || bindType==''){
      // 	return
      // }
      //console.log(bindType)
      let ins = window.location.href;

      console.log(ins.length);
      if (ins.length > 45) {
        this.wxurl = ins.match("code")[0];
        let i = ins.indexOf("=") + 1;
        let s = ins.indexOf("&");
        let is = encodeURI(ins.substring(i, s));
        //console.log(i)
        //console.log(is)
        //console.log(s)
        if (this.wxurl == "code") {
          if (ins.indexOf("980000") !== -1) {
            localStorage.setItem('loginDetail', 'wx')
            //console.log(this.wxurl)
            let data = await this.$api.lwxCallBack({
              code: is,
              state: "980000",
            });
            let url = ins.replace(/(\?|#)[^'"]*/, '');

            window.history.pushState({}, 0, url);
            //console.log(data)
            if (data.data.token) {
              //console.log(data)
              localStorage.setItem("UserToken", data.data.token);
              localStorage.setItem(
                "userInfo",
                JSON.stringify(data.data.userInfo)
              );
              localStorage.setItem("userId", data.data.user_id);
              localStorage.setItem("bindType", "");
              this.$router.go(0);
            } else {
              //console.log("绑定wx")
              localStorage.setItem("unionid", data.data.data.unionid);
              localStorage.setItem("access_token", data.data.data.access_token);
              localStorage.setItem("openid", data.data.data.openid);
              this.openLogin("bind");
            }
          } else if (ins.indexOf('980614') !== -1) {
            console.log('qq')
            localStorage.getItem('loginDetail', 'qq')
            const data = await this.$api.qqCallBack({
              code: is,
              state: 980614,
            });
            let url = ins.replace(/(\?|#)[^'"]*/, '');

            window.history.pushState({}, 0, url);
            if (data.data.token) {
              //console.log(data)
              localStorage.setItem("UserToken", data.data.token);
              localStorage.setItem(
                "userInfo",
                JSON.stringify(data.data.userInfo)
              );
              localStorage.setItem("userId", data.data.user_id);
              localStorage.setItem("bindType", "");
              this.$router.go(0);
            } else {
              //console.log("绑定qq")
              localStorage.setItem("appid", data.data.data.appid);
              localStorage.setItem("access_token", data.data.data.access_token);
              localStorage.setItem("openid", data.data.data.openid);
              this.openLogin("bind");
            }
          }
        }
      } else {
        return;
      }
    },
  },

  created() {

    this.geturl();
    console.log('ni')
    // this.getCategoryDatas(1,3,'kiss')
    //console.log(this)
    // this.$loading(true);
    var tid = this.$route.query.tid;
    this.listTid = this.$route.query.tid;
    if (this.$route.query.mid) {
      this.listMid = this.$route.query.mid;
    } else {
      this.listMid = this.zxMid;
    }
    if (
      localStorage.getItem("UserToken") &&
      JSON.parse(localStorage.getItem("record"))
    ) {
      //console.log("截取")
      this.Answerrecord = JSON.parse(localStorage.getItem("record"));
      //console.log(this.Answerrecord.length,"长度")
      if (this.Answerrecord.length >= 6) {
        window.localStorage.removeItem(`${this.Answerrecord[0].quesId}`);
        window.localStorage.removeItem(`${this.Answerrecord[0].quesId}time`);
        this.Answerrecord.splice(0, 1);
      }
    }


    this.getData(this.user_id, tid, this.listMid);
    // this.getPersonalData(this.user_id);
    // this.lastPractice();
    //console.log(12345)
    var that = this;
    EventBus.$on("imgs", (res) => {
      //console.log(res,"数组长度")
      console.log(res, "数组长度");
      that.imgslength = res?.length || 0;
    });
    this.answerList = localStorage.getItem("listName");
    console.log(localStorage.getItem("listName"));

    return;
    this.listTabSlide(
      localStorage.getItem("listName"),
      localStorage.getItem("listid"),
      localStorage.getItem("listtitle")
    );
  },
  mounted() { },
  components: {
    Login,
    Nav,
  },
  destroyed() {
    this.$loading().close();
  },
};
</script>

<style scoped="scoped" lang="scss">
.box_title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: #333;

  img {
    margin-right: 10px;
  }
}

.list-home {
  /*display: flex;
		 flex-flow: nowrap;
		justify-content: space-between; */
}

.nav_box {
  background: #fff;
  border-radius: 6px;
  padding: 10px 30px;
  border: 1px solid #ebebeb;

  .list-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #666666;
    height: auto;
    line-height: 24px;
    border-bottom: 1px dashed #eee;
    position: relative;

    .updatetext {
      position: relative;
      // top: -27px;
      left: 0px;
    }

    .liheight {
      padding: 15px 15px !important;
    }

    .left_titles {
      font-weight: bold;
      color: #333;
      width: 75px;
    }

    ol {
      display: flex;
      flex: 1;
      justify-content: flex-start;
      flex-direction: row;
      flex-wrap: wrap;
      box-sizing: border-box;
      position: relative;
      padding: 14px 0;
    }

    li {
      padding: 15px 15px;
      font-size: 14px;
      color: #333;
      font-weight: 500;
      position: relative;
      overflow: hidden;
      box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.1);
      cursor: pointer;
      margin: 0 0 5px 0;
    }

    li:before {
      content: "";
      height: 2px;
      width: 100%;
      position: absolute;
      top: 0px;
      left: 150px;
      background-color: rgb(235, 227, 227);
    }

    //  li:hover::before{
    // 	 top:9px;
    // 		left:0%;
    // 		z-index: 100;
    // 		background-color: rgb(255, 65, 65);
    // 		transition: all 0.2s cubic-bezier(.06,.34,.92,.34)
    // 	 }
    li:hover {
      background: #f24f5d;
      color: white;
    }

    .active {
      color: #e60012;
      font-weight: bold;
      border-bottom: 2px solid red;
    }
  }

  .list-title:last-child {
    border: none;
  }
}

.content_box {
  display: flex;
  justify-content: space-between;
  padding-top: 30px;

  .list {
    border-radius: 6px;
    padding: 0 30px;
    border: 1px solid #ebebeb;
    flex: 1;
    background: #fff;
    padding: 30px;

    .list-tab-con {
      border-radius: 18px;
      background-color: #fff;
      margin-top: -30px;
      overflow: hidden;

      .el-menu {
        border-right: none;
      }

      .el-submenu__icon-arrow {
        display: none;
      }
    }

    .list-tab {
      margin-top: 15px;
      border-radius: 18px;

      ol {
        display: flex;
        /* overflow: hidden; */
        background-color: #f7f7f7;
        border-radius: 18px 18px 0 0;

        li {
          flex: 1;
          text-align: center;
          padding: 18px 0;
          position: relative;
          font-size: 16px;
          color: #999;
          cursor: pointer;

          span {
            position: relative;
            z-index: 1;
          }
        }

        li:hover {
          color: #333;
        }

        .active {
          color: #e60012;
        }

        .active:hover {
          color: #e60012;
        }

        .active::before {
          content: "";
          position: absolute;
          display: block;
          width: 216px;
          height: 60px;
          background: url("/images/7.png");
          background-size: 100% 100%;
          left: -38px;
          top: 0;
        }

        .active:first-child:before {
          background: url("/images/7_f.png");
          background-size: 100% 100%;
          left: -10px;
          width: 188px;
        }

        .active:last-child:before {
          background: url("/images/7_l.png");
          background-size: 100% 100%;
          left: auto;
          right: -10px;
          width: 188px;
        }
      }
    }
  }
}

.list-sapce {
  background-color: #f7f7f7;
  height: 30px;
}

.list-box {
  border-bottom: 1px solid #f3f3f3;
  overflow: hidden;
}

.list-tab-a-box {
  position: relative;
}

.list-tab-a {
  overflow: hidden;
  padding: 0 20px;
  height: 56px;
  line-height: 56px;
}

.list-tab-a i,
.list-tab-b i {
  float: left;
  display: block;
  width: 21px;
  height: 21px;
  background: url("/images/icon_tk_07_s.png");
  background-size: 100% 100%;
  margin: 0 10px 0 0;
}

.list-box-active .list-tab-a i,
.list-box-actives i {
  background: url("/images/icon_tk_07.png") !important;
  background-size: 100% 100%;
}

.list-tab-a p {
  float: left;
  width: 50%;
  font-size: 16px;
  color: #000;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.list-tab-a div {
  float: right;
  color: #666;
  margin-right: 60px;
}

.list-tab-b-box {
  padding: 0 0 0 30px;
  position: relative;
}

.list-tab-bs {
  margin-right: -9px !important;
}

.list-tab-b {
  padding-left: 27px;
  color: #666;
  overflow: hidden;
  position: relative;
  line-height: 56px;
  border-top: 1px solid #f3f3f3;
}

.list-tab-b p {
  float: left;
  width: 50%;
  font-size: 14px;
  color: #000;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.list-tab-b div {
  float: right;
  color: #666;
  margin-right: 60px;
}

.contant {
  transition: all 0.4s ease 0s;
}

.list-box-active .contant {
  display: block;
}

.list-tab-a-box:hover,
.list-tab-b-box:hover {
  background-color: rgba(16, 174, 235, 0.05);
  cursor: pointer;
}

.list-right {
  width: 280px;
  margin-left: 20px;
}

/*未登录*/
.test-login {
  border-radius: 6px;
  border: 1px solid #ebebeb;
  background: #fff;
  text-align: center;
  padding: 30px;
}

.test-login button {
  width: 200px;
  height: 40px;
  margin: 20px auto auto auto;
  font-size: 16px;
}

.list-total {
  background: #fff;
  padding: 20px 0;
  text-align: center;
  border: 1px solid #ebebeb;
  margin-top: 20px;
}

.list-total h3 {
  color: #333;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
}

.list-total p {
  font-size: 16px;
  overflow: hidden;
  margin-top: 20px;
}

.list-total p span {
  display: block;
  float: left;
  width: 50%;
  font-size: 14px;
  color: #999;
}

.list-total p em {
  display: block;
  color: #e60012;
  font-size: 18px;
}

.list-total .circlechart2 {
  position: relative;
  display: block;
  width: 130px;
  height: 130px;
  float: none;
  margin: 20px auto;
}

.list-total .circlechart2 span {
  display: block;
  width: 100px;
  height: 100px;
  background: #eee;
  border-radius: 100%;
  top: 15px;
  left: 15px;
  line-height: 100px;
  color: #e60012;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  position: absolute;
}

.list-data {
  border-radius: 6px;

  border: 1px solid #ebebeb;
  background: #fff;
  margin: 20px auto auto auto;
}

.list-data img {
  margin-right: 5px;
  position: relative;
  top: -2px;
  height: 16px;
}

.list-data h3 {
  height: 60px;
  line-height: 60px;
  font-size: 15px;
  color: #333;
  padding: 0 20px;
  font-weight: bold;

  img {
    width: 24px;
    height: 24px;
  }
}

.list-data p a {
  display: block;
  height: 60px;
  line-height: 60px;
  padding: 0 20px;
  color: rgb(26, 8, 8);
  border-top: 1px solid #ebebeb;
}

.list-data p a:hover,
.list-data p a:hover em {
  color: #e60012;
}

.list-data p a em {
  float: right;
  color: #e60012;
  font-weight: bold;
}

.list-data p:last-child em {
  color: #aaa;
}

.list-last {
  border-radius: 6px;
  padding: 0 15px;
  border: 1px solid #ebebeb;
  background: #fff;
  margin: 20px auto auto auto;
  overflow: auto;
}

.list-last img {
  margin-right: 5px;
  position: relative;
  top: -2px;
}

.list-last h3 {
  height: 60px;
  line-height: 60px;
  font-size: 15px;
  color: #333;
  padding: 0 20px;
  font-weight: bold;
}

.list-last p {
  border-top: 1px solid #ebebeb;
  text-align: center;
  padding: 20px 0;
}

.list-last dl {
  padding: 20px;
  border-top: 1px solid #ebebeb;
  overflow: hidden;
}

.list-last dt {
  font-size: 16px;
  color: #333;
}

.list-last dd {
  color: #999;
  margin: 10px 0;
}

.list-last a {
  display: block;
  float: right;
  width: 78px;
  height: 28px;
  border: 1px solid#e60012;
  color: #e60012;
  text-align: center;
  line-height: 28px;
  border-radius: 15px;
}

.list-last a:hover {
  background: #e60012;
  color: #fff;
}

.list-single .list-tab-a i {
  background: none;
  position: relative;
}

.list-single .list-tab-a i::before {
  content: "";
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background-color: #999;
  left: 5px;
  top: 7px;
  position: absolute;
}

.list-tab-a-vip img {
  position: relative;
  left: 0;
  top: 2px;
}

.win-report {
  background-color: #fff;
  position: relative;
  text-align: center;
  border-radius: 10px;
  padding: 20px 0 30px 0;
}

.win-report span {
  position: absolute;
  width: 26px;
  height: 26px;
  border-radius: 100%;
  background-color: #e8e8e8;
  color: #fff;
  font-size: 20px;
  right: 10px;
  top: 10px;
  cursor: pointer;
}

.win-report div {
  background: url("/images/15.png") center no-repeat;
  min-height: 304px;
}

.win-report p {
  padding-top: 40px;
}

.win-report p img {
  width: 160px;
  height: 160px;
  border: 12px solid #eee;
  border-radius: 10px;
  margin: 0 auto;
}

.win-report em {
  font-size: 14px;
  color: #333;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}

.list-lasts {
  display: inline-block;
  display: flex;
  align-items: center;
  width: 238px;
  height: 60px;
  line-height: 60px;
  font-size: 15px;
  color: #333;
  padding: 0 20px;
  font-weight: bold;
  background: #fff;
  margin: -20px 0 0px 0;
  border: 1px solid #ebebeb;
}

.list-lasts img {
  margin-right: 5px;
}

.list-lasts i {
  margin-left: 110px;
}

.transition-box {
  margin-bottom: 10px;
  width: 200px;
  height: 100px;
  border-radius: 4px;
  background-color: #409eff;
  text-align: center;
  color: #fff;
  padding: 40px 20px;
  box-sizing: border-box;
  margin-right: 20px;
}

.el-dropdown-menu__item {
  width: 240px;
  line-height: 25px !important;
  padding: 5px 20px !important;
  border-top: 1px solid #ccc;
}

.el-dropdown-menu__item:hover {
  color: #666 !important;
  background: none !important;
}

.demonstrationspan {
  text-overflow: ellipsis;
  line-clamp: 2;
  height: 40px;
  display: inline-block;
}

.demonstrationspan:hover {
  color: rgb(221, 19, 19) !important;
}

.demonstrationspanspan1 {
  display: flex;
  align-items: center;
}

.block-col-2 {}

.demonstrationspanspan1 span {
  display: inline-block;
  width: 50px;
}

.el-icon-close {
  position: relative;
}

.el-icon-close::before {
  position: absolute;
  top: -27px;
  left: -377px;
}

.el-icon-close:hover {
  font-size: 25px !important;
}

.list-box-list-two {
  position: relative;
}

.list-box-list-two-low {
  position: absolute;
  top: 0px;
  left: -87px;
  font-size: 12.6px;
  color: #ee0c17;
  display: flex;
  width: 100px;
}

.list-box-list-two-low img {
  width: 17px !important;
  height: 17px;
  top: 3px !important;
  left: -20px !important;

}

.download {
  position: absolute;
  top: -2px;
  left: -102px;

}

.transition-box {
  margin-bottom: 10px;
  width: 200px;
  height: 100px;
  border-radius: 4px;
  background-color: #409EFF;
  text-align: center;
  color: #fff;
  padding: 40px 20px;
  box-sizing: border-box;
  margin-right: 20px;
}
</style>
